export default __webpack_public_path__ + "static/media/AGC_2024_R1_QP_Class_5.31d6cfe0.pdf";